import AgencyVisitList from "./components/AgencyVisitList"

export default function AgencyVisitsPage() {
  return <AgencyVisitList />
}
